import React from "react";
import PropTypes from "prop-types";
import {
  CCard,
  CCardBody,
  CButton,
  CFormSelect,
  CSpinner,
} from "@coreui/react";
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
import i18n from "../../../../i18n";

const FilterPanel = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  devices,
  selectedDevice,
  setSelectedDevice,
  trucks,
  selectedTruck,
  setSelectedTruck,
  onApply,
  loading,
  availableDates,
}) => {

  const isDateAvailable = (date) => {
    if (availableDates === null) return true;
    if (availableDates.length === 0) return false;
    const dateStr = dayjs(date).format('YYYY-MM-DD');
    return availableDates.includes(dateStr);
  };

  return (
    <CCard className="mb-4 shadow-sm border-0">
      <CCardBody className="d-flex flex-wrap gap-3 align-items-center">
        {/* Дата начала */}
        <div className="d-flex align-items-center">
          <label className="text-muted small fw-bold text-nowrap mb-0 me-2" htmlFor="start-date">
            {i18n.t('filter_panel.start_date_label', 'Дата начала:')}
          </label>
          <DatePicker
            id="start-date"
            selected={startDate}
            onChange={setStartDate}
            className="form-control form-control-sm"
            showTimeSelect
            dateFormat="dd.MM.yyyy HH:mm"
            locale="ru"
            filterDate={isDateAvailable}
          />
        </div>

        {/* Дата окончания */}
        <div className="d-flex align-items-center">
          <label className="text-muted small fw-bold text-nowrap mb-0 me-2" htmlFor="end-date">
            {i18n.t('filter_panel.end_date_label', 'Дата окончания:')}
          </label>
          <DatePicker
            id="end-date"
            selected={endDate}
            onChange={setEndDate}
            className="form-control form-control-sm"
            showTimeSelect
            dateFormat="dd.MM.yyyy HH:mm"
            locale="ru"
            filterDate={isDateAvailable}
          />
        </div>

        {/* Экскаватор */}
        <div className="d-flex align-items-center">
          <label className="text-muted small fw-bold text-nowrap mb-0 me-2" htmlFor="device-select">
            {i18n.t('filter_panel.excavator_label', 'Экскаватор:')}
          </label>
          <CFormSelect
            id="device-select"
            size="sm"
            value={selectedDevice}
            onChange={(e) => setSelectedDevice(e.target.value)}
            style={{ minWidth: "160px" }}
          >
            <option value="">{i18n.t('filter_panel.all_excavators', 'Все экскаваторы')}</option>
            {devices.map((d) => (
              <option key={d.id} value={d.id}>
                {d.name}
              </option>
            ))}
          </CFormSelect>
        </div>

        {/* Самосвал */}
        <div className="d-flex align-items-center">
          <label className="text-muted small fw-bold text-nowrap mb-0 me-2" htmlFor="truck-select">
            {i18n.t('filter_panel.dump_truck_label', 'Самосвал:')}
          </label>
          <CFormSelect
            id="truck-select"
            size="sm"
            value={selectedTruck}
            onChange={(e) => setSelectedTruck(e.target.value)}
            style={{ minWidth: "160px" }}
          >
            <option value="">{i18n.t('filter_panel.all_dump_trucks', 'Все самосвалы')}</option>
            {trucks.map((t) => (
              <option
                key={t.id}
                value={t.id}
              >{`${t.brand} (${t.plate_number})`}</option>
            ))}
          </CFormSelect>
        </div>

        {/* Кнопка действия */}
        <CButton
          color="primary"
          size="sm"
          onClick={onApply}
          disabled={loading}
          className="fw-bold px-4"
        >
          {loading ? <CSpinner size="sm" /> : "{i18n.t('filter_panel.show', 'Показать')}"}
        </CButton>
      </CCardBody>
    </CCard>
  );
};

FilterPanel.propTypes = {
  startDate: PropTypes.instanceOf(Date).isRequired,
  setStartDate: PropTypes.func.isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
  setEndDate: PropTypes.func.isRequired,
  devices: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedDevice: PropTypes.string.isRequired,
  setSelectedDevice: PropTypes.func.isRequired,
  trucks: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedTruck: PropTypes.string.isRequired,
  setSelectedTruck: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  availableDates: PropTypes.array,
};

export default FilterPanel;